import { HackleInAppMessage } from "../../../public/model"
import BrowserPropertyProvider from "../../property/BrowserPropertyProvider"
import { WebAppInAppMessageView } from "./HackleWebAppInAppMessage"
import { HackleAppInvocationProcessor } from "../invocator/HackleAppInvocationProcessor"
import { CloseInAppMessageViewInvocation } from "../invocator/Invocation"

export class HackleWebAppInAppMessageView implements WebAppInAppMessageView {
  constructor(
    readonly id: string,
    readonly inAppMessage: HackleInAppMessage,
    private readonly invocationProcessor: HackleAppInvocationProcessor,
    private readonly browserPropertyProvider: BrowserPropertyProvider
  ) {}

  close(): void {
    try {
      const invocation: CloseInAppMessageViewInvocation = {
        command: "closeInAppMessageView",
        parameters: { viewId: this.id },
        browserProperties: this.browserPropertyProvider.getBrowserProperties()
      }
      this.invocationProcessor.processAsync(invocation)
    } catch {}
  }
}
